import { Instruction } from "../Instruction";
import { ProgramModel } from "../ProgramContext";

export class FaceLeftInstruction extends Instruction<"face-left"> {
  readonly type = "face-left";

  act(context: ProgramModel) {
    context.cursorDirection = "left";
  }
}
